module.exports = __webpack_public_path__ + "img/tita.61674e59.jpg";